/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/time';
import '../../../common/countries';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "reporting": {
                    "nested": {
                      "SortParams": {
                        "fields": {
                          "field": {
                            "type": "squareup.beemo.api.v2.reporting.SortField",
                            "id": 1,
                            "rule": "optional"
                          },
                          "order": {
                            "type": "squareup.beemo.api.v2.reporting.SortOrder",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SortField": {
                        "values": {
                          "TIME": 1
                        }
                      },
                      "SortOrder": {
                        "values": {
                          "ASC": 1,
                          "DESC": 2
                        }
                      },
                      "TimeWindow": {
                        "fields": {
                          "beginTime": {
                            "type": "squareup.common.time.DateTime",
                            "id": 1,
                            "rule": "optional"
                          },
                          "endTime": {
                            "type": "squareup.common.time.DateTime",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "RequestParams": {
                        "fields": {
                          "merchantToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "beginTime": {
                            "type": "squareup.common.time.DateTime",
                            "id": 2,
                            "rule": "optional"
                          },
                          "endTime": {
                            "type": "squareup.common.time.DateTime",
                            "id": 3,
                            "rule": "optional"
                          },
                          "creatorToken": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "selectedPaymentToken": {
                            "type": "string",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "sortParam": {
                            "type": "squareup.beemo.api.v2.reporting.SortParams",
                            "id": 6,
                            "rule": "repeated"
                          },
                          "timeFilter": {
                            "type": "squareup.beemo.api.v2.reporting.TimeWindow",
                            "id": 7,
                            "rule": "optional"
                          },
                          "subunitMerchantToken": {
                            "type": "string",
                            "id": 8,
                            "rule": "repeated"
                          },
                          "tzName": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "eventBased": {
                            "type": "bool",
                            "id": 10,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "selectedBillToken": {
                            "type": "string",
                            "id": 11,
                            "rule": "repeated"
                          },
                          "requestFlags": {
                            "type": "squareup.beemo.api.v2.reporting.RequestFlags",
                            "id": 12,
                            "rule": "optional"
                          },
                          "startOfDayOffsetMinutes": {
                            "type": "int32",
                            "id": 13,
                            "rule": "optional"
                          },
                          "countryCode": {
                            "type": "squareup.common.countries.Country",
                            "id": 14,
                            "rule": "optional"
                          },
                          "beemoInternalRequestFlags": {
                            "type": "squareup.beemo.api.v2.reporting.RequestParams.BeemoInternalRequestFlags",
                            "id": 100,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "BeemoInternalRequestFlags": {
                            "fields": {
                              "transactionsTimeRangeFromBewfoStartTimeMs": {
                                "type": "int64",
                                "id": 1,
                                "rule": "optional"
                              },
                              "useNewLedgerSummaryEndpoint": {
                                "type": "bool",
                                "id": 4,
                                "rule": "optional"
                              },
                              "useLedgerSummaryResultsInSettlementReportResponse": {
                                "type": "bool",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "RequestFlags": {
                        "fields": {
                          "skipLedgerFees": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "skipCostOfGoodsSold": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "ignoreItemsServiceFailures": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "forceIncludeFutureEffectiveAtAdjustmentFees": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "fetchContactTokens": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "allowPartialFanouts": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SortParams && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SortField && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SortOrder && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.TimeWindow && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.RequestParams && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.RequestParams?.nested?.BeemoInternalRequestFlags && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.RequestFlags) {
  $root.addJSON(jsonData);
}

/**
 * specifies a field to sort
 *
 * SOURCE SortParams @ squareup/beemo/v2/reporting/request.proto at 12:1
 */
export const SortParams = $root.lookupType('squareup.beemo.api.v2.reporting.SortParams');
fixType(SortParams);
Builder.createAndAttachToType(SortParams);
/**
 * SOURCE SortField @ squareup/beemo/v2/reporting/request.proto at 17:1
 */
export const SortField = $root.lookupEnum('squareup.beemo.api.v2.reporting.SortField').values;
/**
 * SOURCE SortOrder @ squareup/beemo/v2/reporting/request.proto at 22:1
 */
export const SortOrder = $root.lookupEnum('squareup.beemo.api.v2.reporting.SortOrder').values;
/**
 * SOURCE TimeWindow @ squareup/beemo/v2/reporting/request.proto at 29:1
 */
export const TimeWindow = $root.lookupType('squareup.beemo.api.v2.reporting.TimeWindow');
fixType(TimeWindow);
Builder.createAndAttachToType(TimeWindow);
/**
 * These parameters are the common fields used for filtering the transactions returned by reports.
 *
 * SOURCE RequestParams @ squareup/beemo/v2/reporting/request.proto at 64:1
 */
export const RequestParams = $root.lookupType('squareup.beemo.api.v2.reporting.RequestParams');
fixType(RequestParams);
Builder.createAndAttachToType(RequestParams);
/**
 * DO NOT USE THIS THIS IS FOR INTERNAL BEEMO TEST USE ONLY
 *
 * SOURCE BeemoInternalRequestFlags @ squareup/beemo/v2/reporting/request.proto at 152:3
 */
RequestParams.BeemoInternalRequestFlags = $root.lookupType('squareup.beemo.api.v2.reporting.RequestParams.BeemoInternalRequestFlags');
fixType(RequestParams.BeemoInternalRequestFlags);
Builder.createAndAttachToType(RequestParams.BeemoInternalRequestFlags);
/**
 * SOURCE RequestFlags @ squareup/beemo/v2/reporting/request.proto at 161:1
 */
export const RequestFlags = $root.lookupType('squareup.beemo.api.v2.reporting.RequestFlags');
fixType(RequestFlags);
Builder.createAndAttachToType(RequestFlags);